// Nur Rechte, die REVA-Nutzer haben können; interne Robot-Rechte (z.B. reva-import-europace-valuation,
// reva-ordersapi-read-license, internal-specification-via-rest) werden hier bewusst nicht gespiegelt
// (siehe account-base/PERMISSIONS.md im Projekt immobrain).
export enum RevaPermission {
    // AvmRole
    INDICATION_COMPARATIVE_PRICE = "indication-comparative-price",
    INDICATION_COMPARATIVE_PRICE_DETAILS = "indication-comparative-price-details",
    INDICATION_COMPARATIVE_VALUE = "indication-comparative-value",
    INDICATION_MARKET_STATS = "indication-market-stats",
    INDICATION_COMPARABLE_OFFERS = "indication-comparable-offers",
    INDICATION_MODEL_METRICS = "indication-model-metrics",
    INDICATION_INCOME_VALUE = "indication-income-value",
    INDICATION_REALASSET_VALUE = "indication-realasset-value",
    INDICATION_VALUES_NHK_BKI = "indication-values-nhk-bki",
    INDICATION_ENERGY_VALUE = "indication-energy-value",
    INDICATION_VALUE = "indication-value",
    INDICATION_FAIR_PRICE = "indication-fair-price",
    OBJECT_INFORMATION = "object-information",
    INDICATION_RENTAL_SEGMENT = "indication-rental-segment",
    LOCATION_MICROMACRO = "location-micromacro",
    LOCATION_MICROMACRO_TEXT = "location-micromacro-text",
    LOCATION_STANDARDGROUNDVALUE = "location-standardgroundvalue",
    LOCATION_CLIMATERISKS = "location-climaterisks",
    LOCATION_POIS = "location-pois",
    LOCATION_NOISE = "location-noise",
    LOCATION_EMISSION = "location-emission",
    LOCATION_MUNICIPALITY_TYPE = "location-municipality-type",
    LOCATION_NEIGHBORHOOD = "location-neighborhood",
    LOCATION_TIMELINES = "location-timelines",
    LOCATION_TIMELINES_FORECAST = "location-timelines-forecast",
    LOCATION_PRICEINDEX = "location-priceindex",
    REPORT_DISTRICT = "report-district",

    // RevaRole
    REVA_UI_CADASTRE = "reva-ui-cadastre",
    REVA_OWNERSHIP_ADMIN = "reva-ownership-admin",
    REVA_OWNERSHIP_ASSIGN = "reva-ownership-assign",
    REVA_LIFECYCLE_CORRECTION = "reva-lifecycle-correction",
    REVA_LIFECYCLE_DELETION = "reva-lifecycle-deletion",
    REVA_LIFECYCLE_FINALIZATION = "reva-lifecycle-finalization",
    REVA_LIFECYCLE_PRE_FINALIZATION = "reva-lifecycle-pre-finalization",
    REVA_LIFECYCLE_REVISION_READONLY = "reva-lifecycle-revision-readonly",
    // #19481: Zweck neuer REVA-IDs (Anlegen, Zweckwechsel, Research-Reiter)
    REVA_PURPOSE_RESEARCH = "reva-purpose-research",
    REVA_PURPOSE_VALUATION = "reva-purpose-valuation",
    REVA_EXPORT_STANDALONE_MAPS_FOR_ADDRESS = "reva-export-standalone-maps-for-address",
    REVA_EXPORT_ANY_VALUATION_FOR_LICENSE = "reva-export-any-valuation-for-license",
    REVA_IDP_ENERGY = "reva-idp-energy",
    LOCATION_MARKETDATA = "location-marketdata",

    // RevaDocRole
    REVA_DOC_FULL_PFANDBG_16 = "reva-doc-full-pfandbg-16",
    REVA_DOC_FULL_BELWERTV_24 = "reva-doc-full-belwertv-24",
    REVA_DOC_LIMITED_SCOPE = "reva-doc-limited-scope",

    // GeneralRole
    ADMINS = "admins",
    IMMOBRAIN_MANAGER = "immobrain-manager",
}

export const ALL_REVA_PERMISSIONS = Object.values(RevaPermission) as RevaPermission[];
